export default __webpack_public_path__ + "static/media/logo.23aa4a68.svg";